import { ConditionTypeEnum } from '.'

export interface IStringCondition {
  /**
   * The values needed to evaluate the condition
   */
  comparison: {
    /**
     * The expected condition value
     *
     * e.g. 'The load requires a lift gate'
     */
    expectedValue?: string
    /**
     * The operator to evaluate the condition, e.g. (contains, does not contain, is, is not, is empty, is not empty)
     */
    operator: StringOperatorEnum
  }
  /**
   * The field name associated with the condition, e.g. ('specialInstructions')
   */
  conditionName: string
  /**
   * The type of condition
   */
  conditionType: ConditionTypeEnum.String
}

export enum StringOperatorEnum {
  CONTAINS = 'contains',
  DOES_NOT_CONTAIN = 'does not contain',
  IS = 'is',
  IS_EMPTY = 'is empty',
  IS_NOT = 'is not',
  IS_NOT_EMPTY = 'is not empty'
}
